.a1{overflow:hidden;}